module.exports = __webpack_public_path__ + "img/tab.d3325224.svg";